import { customAlphabet } from 'nanoid';

// Generates an `X-Request-Id` for dokka-pay requests: 32 lowercase hex chars
// (128 bits), matching the backend's x-dokka-request-id format
// (e.g. 803fe2524201a8d8b9eeb848d65a6d6f). Shared by the typed payApi
// interceptor (services/api/interceptors) and the legacy pay request path
// (lib/apiHelpers) so both emit the same format.
export const generateRequestId = customAlphabet('0123456789abcdef', 32);
